import { Entity } from '@common/types/Entity';
import { theme } from '@prophecy/theme';
import { Stack, StackItem, Text } from '@prophecy/ui-v3';
import { DefaultRecordType } from '@prophecy/ui-v3/Table/types';
import React from 'react';
import styled from 'styled-components';

import { SchemaType } from '../config/types';
import { useEntityTableSchema, getEntityTableSortConfigVariables } from './Config';
import { EntityTable } from './EntityTable';

type Props = {
  uid: string;
  entity: Entity.Pipeline;
};

const StyledStack = styled(Stack)`
  min-height: 0;
  overflow: auto;
`;

export default function PipelineReadWriteDatasets({ uid, entity }: Props) {
  const sortConfigVariables = getEntityTableSortConfigVariables(entity);
  const readDataSetSchema = useEntityTableSchema(entity, Entity.readDatasets) as SchemaType<DefaultRecordType>;
  const writeDatasetSchema = useEntityTableSchema(entity, Entity.writeDatasets) as SchemaType<DefaultRecordType>;
  return (
    <StyledStack gap={theme.spaces.x40} height='100%' align='space-between' grow='1'>
      <Stack gap={theme.spaces.x12} height='50%'>
        <Text level='sm'>Read Datasets</Text>
        <StackItem grow='1'>
          <EntityTable schema={readDataSetSchema} sortConfigVariables={sortConfigVariables} variables={{ uid }} />
        </StackItem>
      </Stack>
      <Stack gap={theme.spaces.x12} grow='1'>
        <Text level='sm'>Write Datasets</Text>
        <StackItem grow='1'>
          <EntityTable schema={writeDatasetSchema} sortConfigVariables={sortConfigVariables} variables={{ uid }} />
        </StackItem>
      </Stack>
    </StyledStack>
  );
}
